/**
 * Virtual procedure IDs for non-database steps in the exam schedule timeline.
 * These are appended after real procedures in ExamProcedureList.
 */
export const EXAM_VIRTUAL_PROCEDURE_ID = {
  EXAM_IMPLEMENTATION: -1,
  RESULT_DETERMINATION: -2,
} as const;

export const EXAM_PROCEDURE_TYPE = {
  PROCEDURE: "procedure",
  EXAM_IMPLEMENTATION: "exam_implementation",
  RESULT_DETERMINATION: "result_determination",
} as const;
